import { compose } from '@cbgms/base/utils/compose'

import Grid, { IGridProps } from './Grid'
import withListData, { IWithKnockDataProps } from './Knock/ListDataMapper'
import withKnockDataLoader, { IWithKnockDataLoaderProps } from './Knock/KnockDataLoader'
import withKnockPagination from './Knock/KnockPagination'
import withColumnsSettings, { IWithColumnSettingsProps } from './Settings/ColumnSettings'
import { IUseListSettingsResult } from './Hooks/use-list-settings'

interface InternalGridProps
  extends IUseListSettingsResult,
    Omit<IWithKnockDataLoaderProps, 'onColumnResize' | 'onColumnMove'>,
    Omit<IWithKnockDataProps, 'data' | 'headers'>,
    Omit<IWithColumnSettingsProps, 'onSettingsReset'>,
    Omit<IGridProps, 'onColumnResize' | 'onColumnMove'> {}

export type DataGridProps = Pick<
  InternalGridProps,
  | 'attached'
  | 'hideUUIDColumns'
  | 'columns'
  | 'dataLoader'
  | 'enums'
  | 'heightOffset'
  | 'headers'
  | 'noDataPlaceholder'
  | 'onColumnMap'
  | 'onDataLoaderInitialized'
  | 'onDoubleClick'
  | 'onRowClassName'
  | 'onRowMap'
  | 'onSettingsDisplay'
  | 'onColumnMove'
  | 'onColumnResize'
  | 'onFilterChange'
  | 'onResetFilters'
  | 'onSettingAdd'
  | 'onSettingRemove'
  | 'onSettingsReset'
  | 'predefinedSearch'
  | 'rowHeight'
  | 'customCellRendererMap'
  | 'handlePageChange'
  | 'handleLimitChange'
  | 'setPaginationProperty'
  | 'getPaginationProperty'
  | 'hideColumnSettings'
  | 'useVinUnmask'
>

const DataGrid = compose<IGridProps, DataGridProps>(withKnockDataLoader, withListData, withColumnsSettings, withKnockPagination)(Grid)

export default DataGrid
